import { useEffect, useState } from "react";
import Mensagens from "../Mensagens";
import { useFetch } from "./Conexao";

export function useScroll(fetch, rota, filtros, totalConfig) {
  const [inx, setInx] = useState(-1);
  const [totais, listarTotais, loadingTotais] = useFetch(null, totalConfig?.initial);
  const [naoListar, setNaoListar] = useState(false);
  const [dados, buscarMais, loadingMaisInternal, setDados] = useFetch(null, null, {
    onRejected: v => {
      Mensagens.showErro(v);
      setDados(dados);
    }
  });

  useEffect(() => {
    if (!!dados?.length)
      setInx(-1);
  }, [filtros]);

  const listar = filtrosNew => {
    const fil = !!filtrosNew ? filtrosNew : filtros;
    setInx(0);
    setNaoListar(false);
    setDados([]);
    buscarMais(() => fetch().post(rota, { ...fil, inx: 0 }));
    if (!!totalConfig) {
      const filTotal = !!filtrosNew ? filtrosNew : totalConfig.filtros;
      listarTotais(() => fetch().post(totalConfig?.rota, { ...filTotal, inx: 0 }));
    }
  };

  const listarMais = () => {
    if (naoListar || dados?.length === totais?.qtd)
      return setNaoListar(true);

    if (inx == -1)
      return listar();

    buscarMais(() => fetch().post(rota, { ...filtros, inx: inx + 1 }), addItens);
  };

  const addItens = itens => {
    if (itens.length === 0 || dados?.length === totais?.qtd)
      setNaoListar(true);
    else {
      setDados([...dados, ...itens]);
      setInx(inx + 1);
    }
  };

  const loadingMais = (!loadingTotais && loadingMaisInternal);
  const continuarListando = !naoListar;

  return [dados, [listar, listarMais, loadingMais], [totais, loadingTotais], setDados, continuarListando];
}
